module.exports = __webpack_public_path__ + "img/error_red_icon.fe8a72ca.svg";